import React from "react";
import _ from "lodash";
import { useI18n } from "Hooks";

import { PageFoldPortraitOutlined, PencilOutlined } from "@toddle-edu/ds-icons";
import {
  Avatar,
  Button,
  Dropdown,
  DropdownMenu,
  FilterLabelButton,
  IconButton,
  PageHeader,
} from "@toddle-edu/ds-web";
import {
  getFilterDropdownOptions,
  getLabValueMap,
} from "AppComponents/ToddleDoc/Modules/utils";

const styles = {
  dropdownContainerStyles: {
    transform: "translateX(12px)",
    zIndex: "1000",
  },
};

const ToddleDocHeader = props => {
  const {
    showEditTitle = false,
    attachmentName = "",
    onSubmit = _.noop,
    onBackClick = _.noop,
    onClickEdit = _.noop,
    showEditDocHeader: showEditDocHeaderFromProps = false,
    showCommentFilters = false,
    disableEdit = false,
    commentFilters,
    onCommentFiltersChange,
  } = props;
  const { t } = useI18n();
  const showEditDocHeader = showEditDocHeaderFromProps && !showCommentFilters;

  const labelValueMap = getLabValueMap(t);

  const icon = (
    <Avatar
      shape={"square"}
      shade={"light"}
      size={"small"}
      iconType="icon"
      dsVersion={"2.0"}
      icon={<PageFoldPortraitOutlined />}
    />
  );

  const editButton = (
    <IconButton
      _legacy_variant="plan"
      variant="neutral"
      type="plain"
      icon={
        <PencilOutlined
          style={{ cursor: "pointer" }}
          size={"xx-small"}
          variant="subtle"
          onClick={onClickEdit}
        />
      }
      size={"small"}
    />
  );

  const handleUpdateFilters = updatedFilters => {
    onCommentFiltersChange(_.get(updatedFilters, "key", "ACTIVE"));
  };

  if (showCommentFilters) {
    return (
      <PageHeader dsVersion={"2.0"}>
        <PageHeader.Left title={""} />
        <PageHeader.Right>
          <div style={styles.dropdownContainerStyles}>
            <Dropdown
              overlay={
                <DropdownMenu
                  dsVersion="2.0"
                  options={getFilterDropdownOptions(t)}
                  onClick={handleUpdateFilters}
                  value={commentFilters}
                  selectionType="radio"
                  showSelection
                />
              }
            >
              <FilterLabelButton
                dsVersion="2.0"
                size="medium"
                label={t("common:comments")}
                labelValue={labelValueMap[commentFilters]}
                variant="neutral"
                type="outlined"
              />
            </Dropdown>
          </div>
        </PageHeader.Right>
      </PageHeader>
    );
  } else if (showEditDocHeader) {
    return (
      <PageHeader dsVersion={"2.0"}>
        <PageHeader.Left title={""} />
        <PageHeader.Right dsVersion={"2.0"}>
          <Button
            variant="neutral"
            type="outlined"
            dsVersion="2.0"
            size="small"
            onClick={onClickEdit}
            disabled={disableEdit}
          >
            {t("classRoom:edit_document")}
          </Button>
        </PageHeader.Right>
      </PageHeader>
    );
  }

  return (
    <PageHeader dsVersion={"2.0"}>
      <PageHeader.Left
        onBackClick={onBackClick}
        title={attachmentName}
        icon={icon}
        titleSuffix={showEditTitle ? editButton : null}
      />
      {showEditTitle ? (
        <PageHeader.Right>
          <Button
            variant="progressive"
            dsVersion="2.0"
            size="medium"
            onClick={onSubmit}
          >
            {t("common:done")}
          </Button>
        </PageHeader.Right>
      ) : null}
    </PageHeader>
  );
};

export default ToddleDocHeader;
